module.exports = __webpack_public_path__ + "static/media/uprightExpandable.5817a682.svg";